export type ValueOf<T> = T[keyof T];

export const OCPIPowerType = Object.freeze({
  AC_1_PHASE: 'AC_1_PHASE',
  AC_3_PHASE: 'AC_3_PHASE',
  DC: 'DC'
})

export type OCPIPowerTypeValues = ValueOf<typeof OCPIPowerType>;
export type OCPIPowerTypeKeys = keyof typeof OCPIPowerType;